import React, { useState } from 'react'
import './GlideLock.css'
import './Glide.css'

import { GrLock, GrUnlock } from 'react-icons/gr'

export default function GlideLock({unlocker = () => {}}) {
  const [locked, setLocked] = useState(true);

  const handleMouseEnter = (e) => {
    setLocked(false);
  }

  const handleMouseLeave = (e) => {
    setLocked(true);
  }

  const handleClick = (e) => {
    unlocker();
  }

  return (
    <div className='glideLock glideCell' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={handleClick}>
      {locked && <GrLock/>}
      {!locked && <GrUnlock />}
    </div>
  )
}
